import type {AgentImage} from './types';

export const MAX_AGENT_IMAGES = 3;
const IMAGE_TYPES = ['image/png', 'image/jpeg', 'image/webp'];
const MAX_IMAGE_BYTES = 5 * 1024 * 1024;

/** Keep original pixels: small labels and branch handles are important in workflow screenshots. */
export const readAgentImage = async (file: File): Promise<AgentImage> => {
    if (!IMAGE_TYPES.includes(file.type)) throw new Error('Choose a PNG, JPEG or WebP image.');
    if (file.size > MAX_IMAGE_BYTES) throw new Error('Each image can be up to 5 MB. Crop a large screenshot before attaching it.');
    const dataUrl = await new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(String(reader.result));
        reader.onerror = () => reject(new Error('The image could not be read. Try attaching it again.'));
        reader.readAsDataURL(file);
    });
    return {id: crypto.randomUUID(), name: file.name || 'Pasted image', mimeType: file.type, data: dataUrl.split(',')[1]};
};

export const imageSource = (image: AgentImage): string => `data:${image.mimeType};base64,${image.data}`;
